import _ from "lodash"
import { mapActions, mapGetters } from "vuex"
import * as reportDict from "../../../constants/report-dictonary"

export default {
  computed: {
    ...mapGetters(["storeConfig"]),
    bus() {
      if (this.content && this.content.recomInfo && this.content.recomInfo.group_busId && this.storeConfig) {
        let [groupId, busId] = this.content.recomInfo.group_busId.split("_")

        let group = _.find(this.storeConfig.itemList, {
          groupId: groupId * 1
        })
        return _.find(group && group.busList, { busId: busId * 1 })
      }

      return null
    }
  },

  methods: {
    ...mapActions(["reportUserAction", "goToOrderPage"]),
    goPropsArea() {
      let pfStructure = this.$route.query.pfStructure
      this.goToOrderPage({
        groupId: this.bus.groupId,
        busId: this.bus.busId,
        query: {
          pfStructure
        }
      })

      this.reportUserAction({
        iformat: reportDict.CLICK.MALL_CONTENT_RELATED_OPSITON,
        pfStructure,
        resultInfo: {
          contentId: (this.content && this.content.contentId) || "",
          pfStructure
        }
      })
    }
  }
}
